<script>
export default {
  name: "low-pre-payment-confirm-modal",
  emits: ["close", "confirm"],
  props: {
    isOpen: Boolean,
    loading: Boolean,
    minimumPrePaymentAmount: {
      type: Number,
      required: true,
    },
    paidAmount: {
      type: Number,
      required: true,
    },
    subject: {
      type: String,
      default: "замовлення",
    },
    confirmLabel: {
      type: String,
      default: "Все одно підтвердити",
    },
    loadingLabel: {
      type: String,
      default: "Зберігається...",
    },
  },
  methods: {
    close() {
      if (this.loading) {
        return;
      }

      this.$emit("close");
    },
  },
};
</script>

<template>
  <div
    v-if="isOpen"
    class="section-modal low-pre-payment-confirm-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="low-pre-payment-confirm-title"
    @click.self="close"
  >
    <div class="section-modal__panel low-pre-payment-confirm-modal__panel">
      <div class="section-modal__header">
        <h2 id="low-pre-payment-confirm-title">Передплата менша за мінімальну</h2>
        <button
          type="button"
          class="section-modal__close"
          :disabled="loading"
          @click="close"
        >
          ×
        </button>
      </div>
      <div class="section-modal__body low-pre-payment-confirm-modal__body">
        <p class="low-pre-payment-confirm-modal__warning">
          Мінімальна передплата для цього {{ subject }} становить {{ minimumPrePaymentAmount }} грн, внесено {{ paidAmount }} грн. Підтвердіть дію, якщо це узгоджено.
        </p>
        <div class="low-pre-payment-confirm-modal__actions">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            :disabled="loading"
            @click="close"
          >
            Скасувати
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-info"
            :disabled="loading"
            @click="$emit('confirm')"
          >
            {{ loading ? loadingLabel : confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.low-pre-payment-confirm-modal__panel {
  max-width: 520px;
}

.low-pre-payment-confirm-modal__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.low-pre-payment-confirm-modal__warning {
  margin: 0;
  padding: 12px;
  border: 1px solid #f2d46b;
  border-radius: 8px;
  color: #513f00;
  background: #fff7d6;
  line-height: 1.35;
  text-align: left;
}

.low-pre-payment-confirm-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
